import Vue from 'vue'
import VueRouter from 'vue-router'

const load = (component) => {
  return () => import(`../views/${component}.vue`)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'splash',
    component: load('SplashScreen')
  },
  {
    path: '',
    component: load('Main'),
    children: [
      {
        path: '/inicio',
        name: 'main',
        component: load('Landing')
      },
      {
        path: '/programacion',
        name: 'programacion',
        component: load('Programacion')
      },
      {
        path: '/libros',
        name: 'libros',
        component: load('Libros')
      },
      {
        path: '/contacto',
        name: 'contacto',
        component: load('Contacto')
      },
      {
        path: '/donaciones',
        name: 'donaciones',
        component: load('Donaciones')
      },
      {
        path: '/blog',
        name: 'blog',
        component: load('BlogView'),
        props: true
      },
      {
        path: '/matutina',
        name: 'matutina',
        component: load('Matutina')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
